import { getClientsPath } from '@app/modules/CustomerList/paths'

export function getClientPath(id: number | string) {
  return `${getClientsPath()}/${id}`
}
